/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrAbdominalCircumference,
  PhrAbdominalCircumferenceFromJSON,
  PhrAbdominalCircumferenceFromJSONTyped,
  PhrAbdominalCircumferenceToJSON,
  PhrBloodPressures,
  PhrBloodPressuresFromJSON,
  PhrBloodPressuresFromJSONTyped,
  PhrBloodPressuresToJSON,
  PhrGOTs,
  PhrGOTsFromJSON,
  PhrGOTsFromJSONTyped,
  PhrGOTsToJSON,
  PhrGPTs,
  PhrGPTsFromJSON,
  PhrGPTsFromJSONTyped,
  PhrGPTsToJSON,
  PhrGammaGTs,
  PhrGammaGTsFromJSON,
  PhrGammaGTsFromJSONTyped,
  PhrGammaGTsToJSON,
  PhrGlucoses,
  PhrGlucosesFromJSON,
  PhrGlucosesFromJSONTyped,
  PhrGlucosesToJSON,
  PhrHDLCholesterols,
  PhrHDLCholesterolsFromJSON,
  PhrHDLCholesterolsFromJSONTyped,
  PhrHDLCholesterolsToJSON,
  PhrHbA1cs,
  PhrHbA1csFromJSON,
  PhrHbA1csFromJSONTyped,
  PhrHbA1csToJSON,
  PhrLDLCholesterols,
  PhrLDLCholesterolsFromJSON,
  PhrLDLCholesterolsFromJSONTyped,
  PhrLDLCholesterolsToJSON,
  PhrMeasurement,
  PhrMeasurementFromJSON,
  PhrMeasurementFromJSONTyped,
  PhrMeasurementToJSON,
  PhrMedicalHistory,
  PhrMedicalHistoryFromJSON,
  PhrMedicalHistoryFromJSONTyped,
  PhrMedicalHistoryToJSON,
  PhrSymptoms,
  PhrSymptomsFromJSON,
  PhrSymptomsFromJSONTyped,
  PhrSymptomsToJSON,
  PhrTriglycerides,
  PhrTriglyceridesFromJSON,
  PhrTriglyceridesFromJSONTyped,
  PhrTriglyceridesToJSON,
  PhrUrinaryGlucose,
  PhrUrinaryGlucoseFromJSON,
  PhrUrinaryGlucoseFromJSONTyped,
  PhrUrinaryGlucoseToJSON,
  PhrUrinaryProtein,
  PhrUrinaryProteinFromJSON,
  PhrUrinaryProteinFromJSONTyped,
  PhrUrinaryProteinToJSON,
  PhrValue,
  PhrValueFromJSON,
  PhrValueFromJSONTyped,
  PhrValueToJSON,
} from "./";

export const PhrClinicalDocumentResultTypename = "PhrClinicalDocumentResult" as const;

/**
 *
 * @export
 * @interface PhrClinicalDocumentResult
 */
export interface PhrClinicalDocumentResult {
  /**
   *
   * @type {PhrAbdominalCircumference}
   * @memberof PhrClinicalDocumentResult
   */
  abdominalCircumferences?: PhrAbdominalCircumference;
  /**
   *
   * @type {PhrBloodPressures}
   * @memberof PhrClinicalDocumentResult
   */
  bloodPressures?: PhrBloodPressures;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrClinicalDocumentResult
   */
  bmi?: PhrMeasurement;
  /**
   *
   * @type {string}
   * @memberof PhrClinicalDocumentResult
   */
  drawBloodTime?: string;
  /**
   *
   * @type {PhrGammaGTs}
   * @memberof PhrClinicalDocumentResult
   */
  gammaGts?: PhrGammaGTs;
  /**
   *
   * @type {PhrGlucoses}
   * @memberof PhrClinicalDocumentResult
   */
  glucoses?: PhrGlucoses;
  /**
   *
   * @type {PhrGOTs}
   * @memberof PhrClinicalDocumentResult
   */
  gots?: PhrGOTs;
  /**
   *
   * @type {PhrGPTs}
   * @memberof PhrClinicalDocumentResult
   */
  gpts?: PhrGPTs;
  /**
   *
   * @type {PhrHbA1cs}
   * @memberof PhrClinicalDocumentResult
   */
  hbA1cs?: PhrHbA1cs;
  /**
   *
   * @type {PhrHDLCholesterols}
   * @memberof PhrClinicalDocumentResult
   */
  hdlCholesterols?: PhrHDLCholesterols;
  /**
   *
   * @type {string}
   * @memberof PhrClinicalDocumentResult
   */
  healthGuidanceLevel?: string;
  /**
   *
   * @type {PhrValue}
   * @memberof PhrClinicalDocumentResult
   */
  height?: PhrValue;
  /**
   *
   * @type {PhrLDLCholesterols}
   * @memberof PhrClinicalDocumentResult
   */
  ldlCholesterols?: PhrLDLCholesterols;
  /**
   *
   * @type {PhrMedicalHistory}
   * @memberof PhrClinicalDocumentResult
   */
  medicalHistory?: PhrMedicalHistory;
  /**
   *
   * @type {string}
   * @memberof PhrClinicalDocumentResult
   */
  metabolicSyndrome?: string;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrClinicalDocumentResult
   */
  nonHdlCholesterol?: PhrMeasurement;
  /**
   *
   * @type {PhrSymptoms}
   * @memberof PhrClinicalDocumentResult
   */
  symptoms?: PhrSymptoms;
  /**
   *
   * @type {PhrTriglycerides}
   * @memberof PhrClinicalDocumentResult
   */
  triglycerides?: PhrTriglycerides;
  /**
   *
   * @type {PhrUrinaryGlucose}
   * @memberof PhrClinicalDocumentResult
   */
  urinaryGlucose?: PhrUrinaryGlucose;
  /**
   *
   * @type {PhrUrinaryProtein}
   * @memberof PhrClinicalDocumentResult
   */
  urinaryProtein?: PhrUrinaryProtein;
  /**
   *
   * @type {PhrValue}
   * @memberof PhrClinicalDocumentResult
   */
  visceralFatArea?: PhrValue;
  /**
   *
   * @type {PhrValue}
   * @memberof PhrClinicalDocumentResult
   */
  weight?: PhrValue;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrClinicalDocumentResult
   */
  readonly __typename?: string;
}

export function PhrClinicalDocumentResultFromJSON(json: any): PhrClinicalDocumentResult {
  return PhrClinicalDocumentResultFromJSONTyped(json, false);
}

export function PhrClinicalDocumentResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhrClinicalDocumentResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrClinicalDocumentResultTypename,

    abdominalCircumferences: !exists(json, "abdominal_circumferences")
      ? undefined
      : PhrAbdominalCircumferenceFromJSON(json["abdominal_circumferences"]),
    bloodPressures: !exists(json, "blood_pressures") ? undefined : PhrBloodPressuresFromJSON(json["blood_pressures"]),
    bmi: !exists(json, "bmi") ? undefined : PhrMeasurementFromJSON(json["bmi"]),
    drawBloodTime: !exists(json, "draw_blood_time") ? undefined : json["draw_blood_time"],
    gammaGts: !exists(json, "gamma_gts") ? undefined : PhrGammaGTsFromJSON(json["gamma_gts"]),
    glucoses: !exists(json, "glucoses") ? undefined : PhrGlucosesFromJSON(json["glucoses"]),
    gots: !exists(json, "gots") ? undefined : PhrGOTsFromJSON(json["gots"]),
    gpts: !exists(json, "gpts") ? undefined : PhrGPTsFromJSON(json["gpts"]),
    hbA1cs: !exists(json, "hb_a1cs") ? undefined : PhrHbA1csFromJSON(json["hb_a1cs"]),
    hdlCholesterols: !exists(json, "hdl_cholesterols")
      ? undefined
      : PhrHDLCholesterolsFromJSON(json["hdl_cholesterols"]),
    healthGuidanceLevel: !exists(json, "health_guidance_level") ? undefined : json["health_guidance_level"],
    height: !exists(json, "height") ? undefined : PhrValueFromJSON(json["height"]),
    ldlCholesterols: !exists(json, "ldl_cholesterols")
      ? undefined
      : PhrLDLCholesterolsFromJSON(json["ldl_cholesterols"]),
    medicalHistory: !exists(json, "medical_history") ? undefined : PhrMedicalHistoryFromJSON(json["medical_history"]),
    metabolicSyndrome: !exists(json, "metabolic_syndrome") ? undefined : json["metabolic_syndrome"],
    nonHdlCholesterol: !exists(json, "non_hdl_cholesterol")
      ? undefined
      : PhrMeasurementFromJSON(json["non_hdl_cholesterol"]),
    symptoms: !exists(json, "symptoms") ? undefined : PhrSymptomsFromJSON(json["symptoms"]),
    triglycerides: !exists(json, "triglycerides") ? undefined : PhrTriglyceridesFromJSON(json["triglycerides"]),
    urinaryGlucose: !exists(json, "urinary_glucose") ? undefined : PhrUrinaryGlucoseFromJSON(json["urinary_glucose"]),
    urinaryProtein: !exists(json, "urinary_protein") ? undefined : PhrUrinaryProteinFromJSON(json["urinary_protein"]),
    visceralFatArea: !exists(json, "visceral_fat_area") ? undefined : PhrValueFromJSON(json["visceral_fat_area"]),
    weight: !exists(json, "weight") ? undefined : PhrValueFromJSON(json["weight"]),
  };
}

export function PhrClinicalDocumentResultToJSON(object?: PhrClinicalDocumentResult | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    abdominal_circumferences: PhrAbdominalCircumferenceToJSON(value.abdominalCircumferences),
    blood_pressures: PhrBloodPressuresToJSON(value.bloodPressures),
    bmi: PhrMeasurementToJSON(value.bmi),
    draw_blood_time: value.drawBloodTime,
    gamma_gts: PhrGammaGTsToJSON(value.gammaGts),
    glucoses: PhrGlucosesToJSON(value.glucoses),
    gots: PhrGOTsToJSON(value.gots),
    gpts: PhrGPTsToJSON(value.gpts),
    hb_a1cs: PhrHbA1csToJSON(value.hbA1cs),
    hdl_cholesterols: PhrHDLCholesterolsToJSON(value.hdlCholesterols),
    health_guidance_level: value.healthGuidanceLevel,
    height: PhrValueToJSON(value.height),
    ldl_cholesterols: PhrLDLCholesterolsToJSON(value.ldlCholesterols),
    medical_history: PhrMedicalHistoryToJSON(value.medicalHistory),
    metabolic_syndrome: value.metabolicSyndrome,
    non_hdl_cholesterol: PhrMeasurementToJSON(value.nonHdlCholesterol),
    symptoms: PhrSymptomsToJSON(value.symptoms),
    triglycerides: PhrTriglyceridesToJSON(value.triglycerides),
    urinary_glucose: PhrUrinaryGlucoseToJSON(value.urinaryGlucose),
    urinary_protein: PhrUrinaryProteinToJSON(value.urinaryProtein),
    visceral_fat_area: PhrValueToJSON(value.visceralFatArea),
    weight: PhrValueToJSON(value.weight),
  };
}
